import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import {
  CreateUser,
  EditUserById,
  LegalEntities,
  ListUser,
  PermissionsTypes,
  PrintersType,
  Roles,
  Settings,
  UserById,
  UserProfile,
} from './types'

export class UsersService {
  static getUsers(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ListUser[]>> {
    return apiService.get<AxiosResponse<ListUser[]>>('/users', config)
  }

  static getRoles(): Promise<AxiosResponse<Roles[]>> {
    return apiService.get<AxiosResponse<Roles[]>>('/userRoles')
  }

  static getLegalEntities(q?: string): Promise<AxiosResponse<LegalEntities[]>> {
    const params = q ? { q } : {}
    return apiService.get<AxiosResponse<LegalEntities[]>>('/legal-entity', {
      params,
    })
  }

  static getPermission(): Promise<AxiosResponse<PermissionsTypes>> {
    return apiService.get<AxiosResponse<PermissionsTypes>>(
      '/userRoles/permissions',
    )
  }

  static getUsersById(
    id: string,
  ): Promise<AxiosResponse<UserById | EditUserById>> {
    return apiService.get<AxiosResponse<UserById | EditUserById>>(
      `/users/${id}`,
    )
  }

  static getRoleById(id: string): Promise<AxiosResponse<Roles>> {
    return apiService.get<AxiosResponse<Roles>>(`/userRoles/${id}`)
  }

  static loadMoreUsers(
    params: AxiosRequestConfig,
  ): Promise<AxiosResponse<ListUser[]>> {
    return apiService.get<AxiosResponse<ListUser[]>>('/users', params)
  }

  static editUser(
    id: string,
    data?: {
      name: string
      legalEntityId?: string
    },
  ): Promise<AxiosResponse> {
    return apiService.put<AxiosResponse>(`/users/${id}/edit`, {
      ...data,
      id,
    })
  }

  static getProfile(): Promise<AxiosResponse<UserProfile>> {
    return apiService.get<AxiosResponse<UserProfile>>('profile')
  }

  static editProfile(data: {
    name: string
    settings?: Settings
  }): Promise<AxiosResponse> {
    return apiService.put<AxiosResponse>('/profile', {
      ...data,
    })
  }

  static changeProfilePassword(data: {
    new_password?: string
  }): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>(`/profile/change-password`, data)
  }

  static changePassword(
    id: string,
    data: {
      new_password?: string
    },
  ): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>(`/users/${id}/change-password`, data)
  }

  static setRoles(
    id: string,
    data: {
      roles: string[]
    },
  ): Promise<AxiosResponse> {
    return apiService.put<AxiosResponse>(`/users/${id}/setRole`, { ...data })
  }

  static updateRole(
    id: string,
    data: {
      name: string
      permissions: string[]
    },
  ): Promise<AxiosResponse> {
    return apiService.put<AxiosResponse>(`/userRoles/${id}`, data)
  }

  static createRole(data: { name: string; permissions: string[] }) {
    return apiService.post(`/userRoles`, {
      ...data,
    })
  }

  static blockUser(userId: string, data: { enabled: boolean }) {
    return apiService.post(`/users/${userId}/block`, {
      ...data,
    })
  }

  static createUser(data: CreateUser): Promise<AxiosResponse<{ id: string }>> {
    return apiService.post(`/users`, {
      ...data,
    })
  }

  static deleteRole(id: string) {
    return apiService.delete(`/userRoles/${id}`)
  }

  static deleteUser(id: string) {
    return apiService.delete(`/users/${id}`)
  }

  static editPrintersUser(
    id: string,
    data?: PrintersType,
  ): Promise<AxiosResponse> {
    return apiService.put<AxiosResponse>(`/users/${id}/edit`, {
      settings: { printers: data },
      id,
    })
  }
}
